import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {Checkbox} from "antd";
import TiresReplacement from "./TiresReplacement";

import "./TiresAndWheelsServices.css";
import connect from "react-redux/es/connect/connect";
import TiresExchange from "./TiresExchange";
import Intervention from "../../../services/Intervention";
import InterventionService from "../../../services/Intervention";
import Constants from "../../../services/Constants";

class TiresAndWheelsServices extends Component {

  constructor(props) {
    super(props);
    const {intervention: {journey}} = this.props;
    const {services, tiresExchange, tiresReplacement} = journey.properties.services;
    const selectedServices = services.map(s=>s.name);
    this.state = {
      id: journey.id,
      selectedServices,
      tiresExchange,
      tiresReplacement,
      pristine: true
    }
  }

  onServicesSave = () => {
    const {id, selectedServices, tiresExchange, tiresReplacement} = this.state;

    let body = {type:Constants.TYPE_TIRES.value, services: selectedServices};
    if (body.services.includes("tiresExchange")) {
      body.tiresExchange = tiresExchange;
    }
    if (body.services.includes("tiresReplacement")) {
      body.tiresReplacement = tiresReplacement;
    }
    this.props.dispatchUpdateServices(id, body);
  };

  onTiresExchangeChange = (tiresExchange, pristine) => {
    this.setState({tiresExchange, pristine: pristine !== undefined ? pristine : false});
  };

  onTiresReplacementChange = (tiresReplacement) => {
    this.setState({tiresReplacement, pristine: true});
  };

  render() {
    const {intl: {formatMessage}, canWrite, intervention, intervention: {journey}, updateJourneyServices: {error = {}}} = this.props;
    const {selectedServices, tiresExchange, tiresReplacement, pristine} = this.state;
    const errors = error.content || {};
    const oas = InterventionService.isOAS(intervention);

    if (!selectedServices) {
      return null;
    }

     const canChange = canWrite && !Intervention.isComplete(intervention);
     return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id:'appointment.detail.services.title'})}
          </h2>
          {pristine &&
            <svg className="bmw-icon bmw-icon-md " aria-hidden="true" style={{marginLeft: 10}}>
              <use className="txt-success" xlinkHref="#icon-checkmark"/>
            </svg>
          }
        </header>

        <div className="box__body">
          <div className="row">
            <div className="col-md-6 col-xxl-6">
              <h3 className="box__subtitle">{formatMessage({id:'appointment.detail.services.requested-services.title'})}</h3>

              <ul className="list">
                {selectedServices.map((name, index) =>
                  <li key={name}>
                    <Checkbox checked={true} disabled={true}>
                      {formatMessage({id:`services.${name}`})}
                    </Checkbox>
                  </li>)}
              </ul>
            </div>
          </div>
            {selectedServices.includes("tiresReplacement") &&
            <div className="row">
              <div className="col-md-12 col-xxl-12">
                <TiresReplacement uuid={journey.uuid} canWrite={canChange} connectedUserId={intervention.customer.id}
                                  errors={errors} tiresReplacement={tiresReplacement} onChange={this.onTiresReplacementChange}/>
              </div>
            </div>
            }

            {selectedServices.includes("tiresExchange") &&
            <div className="row">
              <div className="col-md-12 col-xxl-12">
                <TiresExchange tiresExchange={tiresExchange} canWrite={canChange} onChange={this.onTiresExchangeChange} errors={errors}/>
              </div>
            </div>
            }
        </div>
        {!oas && canChange &&
          <footer className="box-footing">
            <h2 className="box-footing__title"/>
            <div className="box-footing__right">
              <button onClick={this.onServicesSave} disabled={pristine} type="primary" className="btn btn-sm btn-primary">{formatMessage({id: 'action.save'})}</button>
            </div>
          </footer>
        }
      </section>
    )
  }
}


const mapStateToProps = state => ({
  updateJourneyServices: state.updateJourneyServices
});

const mapDispatchToProps = dispatch => ({
  dispatchUpdateServices: (id, body) => dispatch({type: 'UPDATE_JOURNEY_SERVICES.REQUEST', id, body}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps)
(injectIntl(TiresAndWheelsServices))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/services/TiresAndWheelsServices.js